import React from 'react';
import { useDropzone } from 'react-dropzone';

interface SvgUploadProps {
  onUpload: (file: File, fileType: string) => void;
}

const SvgUpload = ({ onUpload }: SvgUploadProps) => {
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      'image/svg+xml': ['.svg'],
      'application/postscript': ['.eps'],  // Add EPS support
      'application/eps': ['.eps'],          // Some clients use this MIME
      'application/x-eps': ['.eps'],        // Extra just in case
      'image/eps': ['.eps'],
      'image/x-eps': ['.eps']
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles[0]) {
        const file = acceptedFiles[0];
        const lowerName = file.name.toLowerCase();
        const fileType = lowerName.endsWith('.svg') ? 'SVG' : lowerName.endsWith('.eps') ? 'EPS' : 'Unknown';
        onUpload(file, fileType);
      }
    },
  });

  return (
    <div className={"hover:bg-gray-100 w-fit"}>
      <div {...getRootProps()} className={"flex flex-col p-4"}>
        <input {...getInputProps()} />
        <p>Drop an SVG or EPS file here, or click to select a file</p>
      </div>
    </div>
  );
};

export default SvgUpload;